import axios from '@/axios.js'

export default {
  fetchPromos ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/promo')
        .then(({data: response}) => {
          commit('SET_PROMOS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchPromo (context, promoId) {
    return new Promise((resolve, reject) => {
      axios.get(`/promo/${promoId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  storePromo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/promo', payload)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  updatePromo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/promo/${payload.id}`, payload.body)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  destroyPromo ({ commit }, promoId) {
    return new Promise((resolve, reject) => {
      axios.delete(`promo/${promoId}`)
        .then((response) => {
          commit('REMOVE_RECORD', promoId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
